import { useState, useEffect, useContext } from 'react';

import {
  bodyScrollCntl,
  formatTime, formatTimeAddMin,
} from '../../../../../../../util/utility';
import { LiveReserveContext } from '../../../LiveLessonReseveContext';
import Loading from '../../../../../../common/loading/Loading';

import {
  LiveReserveSituationDisplaySituations,
  LiveReserveSituationValue,
  LiveReserveSituationItem,
} from '../../../../../../../models/lesson/live/reserve/situation/LiveReserveSituation';


// 予約確認モーダル
function LiveReserveSubmitConfirm(props: any) {

  const isDispConfirm = props.isDispConfirm;
  const setIsDispConfirm = props.setIsDispConfirm;

  const {
    lessonTermMinute,
    instructors, instId,
    lsnMin, isTrial,
    calendar, selectedScheduleId,
    displaySituations, selectedSituation,
    requestContent,
    formRef,
  } = useContext(LiveReserveContext);

  const [dispInstName, setDispInstName] = useState<string>('');
  const [dispTime, setDispTime] = useState<string>('');
  const [dispDate, setDispDate] = useState<string>('');
  const [dispDateTime, setDispDateTime] = useState<string>('');
  const [dispSitucation, setDispSituation] = useState<string>('');

  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);


  // モーダル表示時に背景スクロールを止める
  useEffect(() => {
    if (isDispConfirm) {
      bodyScrollCntl(false);
    } else {
      bodyScrollCntl(true);
    }

    // アンマウント時にも戻す（安全のため）
    return () => {
      bodyScrollCntl(true);
    };
  }, [isDispConfirm]);


  const closeModal = () => {
    if(!isSubmitting) {
      setIsDispConfirm(false);
    }
  }


  // 講師名
  useEffect(() => {
    let newInstName = '講師を指定しない';
    if(instId && instructors) {
      const selectInst = instructors.find((inst: any) => {
        return inst.inst_id == instId
      })
      if(selectInst?.name) {
        newInstName = selectInst.name;
      }
    }
    setDispInstName(newInstName);
  }, [instructors, instId])
  
  // レッスン時間
  useEffect(() => {
    let newDispTime = lsnMin + '分';
    switch(lsnMin) {
      case lessonTermMinute:
        newDispTime += isTrial ? '（無料1回分）' : '（3チケット）';
        break;
      case lessonTermMinute*2:
        newDispTime += isTrial ? '（無料2回分）' : '（6チケット）';
        break;
      case lessonTermMinute*3:
        newDispTime += isTrial ? '（無料3回分）' : '（9チケット）';
        break;
      default:
        newDispTime = '';
    }
    setDispTime(newDispTime);
  }, [lsnMin, isTrial])

  // 予約日時
  useEffect(() => {
    for(const date in calendar) {
      const times = calendar[date];
      for(const time in times) {
        if(times[time] == selectedScheduleId) {
          setDispDate(date);
          // 時間を"HH:MM"に整形
          setDispDateTime(`${formatTime(time)} 〜 ${formatTimeAddMin(time, lsnMin)}`);
        }
      }
    }
  }, [calendar, selectedScheduleId])

  // 実践内容
  useEffect(() => {
    if (!displaySituations) return;
    for (const situation of displaySituations as LiveReserveSituationDisplaySituations) {
      const valueMap: LiveReserveSituationValue = situation.value;
      for (const key in valueMap) {
        const category: LiveReserveSituationItem = valueMap[key];
        if (category.id === selectedSituation) {
          setDispSituation(category.situation);
        }
      }
    }
  }, [displaySituations, selectedSituation]);


  // フォーム送信
   const handleSubmit = () => {
    if (formRef.current && !isSubmitting) {
      // 送信中
      setIsSubmitting(true);
      try {
        // 予約実施
        formRef.current.submit();
        setTimeout(() => {
          // モーダルを閉じる
          closeModal();
        }, 300);
      } finally {
        setTimeout(() => {
          setIsSubmitting(false);
        }, 500);
      }
    }
  };



  return (
    <>
    {isDispConfirm &&
      <>
      {/* backdrop */}
      <div className="modal-backdrop fade in"></div>

      {/* modal */}
      <div
        id="practice_confirm_modal"
        className="modal fade in"
        style={{ display: 'block', overflow: 'auto' }}
        tabIndex={-1}
      >
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-header">
              {!isSubmitting &&
                <button
                  type="button"
                  className="close"
                  onClick={closeModal}
                  aria-hidden="true"
                >
                  <big>×</big>
                </button>
              }
              <h4 className="modal-title">
                <small>以下の内容で送信してよろしいですか？</small>
              </h4>
            </div>

            <div className="modal-body text-center">
              <table className="table table-bordered table-condensed table-striped small">
                <tbody>
                  <tr>
                    <td className="text-right text-nowrap">講師</td>
                    <td className="text-left" style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
                      {dispInstName}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-right text-nowrap">レッスン時間</td>
                    <td className="text-left">
                      {dispTime}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-right text-nowrap">予約日時</td>
                    <td className="text-left">
                      {dispDate}&nbsp;&nbsp;
                      <br className="visible-xs" />
                      {dispDateTime}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-right text-nowrap">実践内容</td>
                    <td className="text-left">
                      {dispSitucation}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-right text-nowrap">コメント</td>
                    <td className="text-left">
                      {requestContent}
                    </td>
                  </tr>
                </tbody>
              </table>

              <div className="text-center">
                {isSubmitting ?
                  <Loading />
                :
                  <>
                    <input
                      style={{ marginBottom: '10px', marginRight: '5px', maxWidth: '100%', whiteSpace: 'normal', }}
                      type="button"
                      onClick={handleSubmit}
                      id="doReserveBtn"
                      className="btn btn-danger btn_customize"
                      value="この内容で予約する"
                      disabled={isSubmitting}
                    />
                    <input
                      style={{ marginBottom: '10px', marginLeft: '5px' }}
                      type="button"
                      onClick={closeModal}
                      className="btn btn-info btn_customize"
                      value="戻る"
                    />
                  </>
                }
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
    }
    </>
  );
}
  
export default LiveReserveSubmitConfirm;